import { defineMessages } from 'react-intl'

export const cookieBannerMessages = defineMessages({
  body: {
    id: 'msp.cookie_banner.body',
    defaultMessage:
      'We use cookies and other technologies to provide and design the functions of our websites optimally, to personalize content and advertisements, to integrate social media and to analyze access to our websites. For this purpose, personal data is collected and used from you.'
  },
  recommendation: {
    id: 'msp.cookie_banner.recommendation_text',
    defaultMessage:
      'We recommend that you allow us to use cookies and other technologies, as well as the processing of the personal data collected with them (i.e. your website usage), for these purposes by giving your consent. In this case, we will share certain information about your use of our website with our respective partners for social media (e.g. Facebook), advertising (e.g. Google), and analytics, including partners in the USA. These partners may combine this information with other data that you have provided or that they have collected as part of your use of other services. There is a risk that your data may not be protected in the same way as in the European Union with these US companies. '
  },
  accept: {
    id: 'msp.cookie_banner.accept',
    defaultMessage:
      'Click "Accept all" to give your consent. You can revoke this consent at any time with effect for the future. Click "Required" to use our websites only with strictly necessary cookies and other technologies. Click "Settings" to get more information and change the scope of your consent.'
  },
  acceptAllButton: {
    id: 'msp.cookie_banner.accept_all_button',
    defaultMessage: 'Accept all'
  },
  rejectAllButton: {
    id: 'msp.cookie_banner.reject_all_button',
    defaultMessage: 'Reject all'
  },
  confirmSelectionButton: {
    id: 'msp.cookie_banner.confirm_selection_button',
    defaultMessage: 'Save selection'
  },
  showDetailsButton: {
    id: 'msp.cookie_banner.show_details_button',
    defaultMessage: 'Settings'
  },
  imprintLinkText: {
    id: 'msp.cookie_banner.imprint_link_text',
    defaultMessage: 'Legal notice'
  },
  imprintPageLink: {
    id: 'msp.cookie_banner.imprint_page_link',
    defaultMessage: '/imprint'
  },
  dataProtectionLinkText: {
    id: 'msp.cookie_banner.data_protection_link_text',
    defaultMessage: 'Data Protection'
  },
  dataProtectionPageLink: {
    id: 'msp.cookie_banner.data_protection_page_link',
    defaultMessage: '/privacy'
  },
  requiredCookieCheckboxText: {
    id: 'msp.cookie_banner.required_cookies_checkbox_text',
    defaultMessage: 'Required (technically necessary)'
  },
  requiredCookieCopyText: {
    id: 'msp.cookie_banner.required_cookies_copy_text',
    defaultMessage:
      'Required cookies help to make a website usable by enabling basic functions such as page navigation and access to secure areas of the website. The website cannot function properly without these cookies (login, storing your products in the shopping cart). However, the information is only sent to the website.'
  },
  functionalCookieCheckboxText: {
    id: 'msp.cookie_banner.functional_cookies_checkbox_text',
    defaultMessage: 'Functional'
  },
  functionalCookieCopyText: {
    id: 'msp.cookie_banner.functional_cookies_copy_text',
    defaultMessage:
      'Functional cookies improve website usage and allow for convenient use (e.g. saving language selection, using the store finder and pack station finder). Functional cookies process information anonymously.'
  },
  perfomanceRelatedCookieCheckboxText: {
    id: 'msp.cookie_banner.performance_related_cookies_checkbox_text',
    defaultMessage: 'Statistics'
  },
  perfomanceRelatedCookieCopyText: {
    id: 'msp.cookie_banner.performance_related_cookies_copy_text',
    defaultMessage:
      'Performance-related cookies help to analyze how a website is used and are set by us or third parties. The effectiveness and functionality of the website are improved by these cookies, for example by analyzing your navigation behavior.'
  },
  marketingRelatedCookieCheckboxText: {
    id: 'msp.cookie_banner.marketing_related_cookies_checkbox_text',
    defaultMessage: 'Marketing'
  },
  marketingRelatedCookieCopyText: {
    id: 'msp.cookie_banner.marketing_related_cookies_copy_text',
    defaultMessage:
      'Marketing cookies are used to display advertising tailored to your interests. Both we and third parties can send you personalized offers. These cookies are automatically set by us and external media if you have made the corresponding settings.'
  },
  cookieModal: {
    id: 'msp.cookie_banner.title',
    defaultMessage: 'Can we offer you some Cookies to your tea?'
  }
})
